import { LoggingMessageInterface } from '../models';
import { Injectable } from '@angular/core';

import { Observable, Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LogChannel } from '../constants';

@Injectable({ providedIn: 'root' })
export class LoggingChannelPubSubService {
  private _publishSubscribeSubject$: Subject<{
    channel: LogChannel;
    payload: LoggingMessageInterface;
  }> = new Subject();
  private _emitter$: Observable<{ channel: LogChannel; payload: LoggingMessageInterface }>;

  constructor() {
    this._emitter$ = this._publishSubscribeSubject$.asObservable();
  }

  public publish(channels: LogChannel[], data: LoggingMessageInterface): void {
    for (const channel of channels) {
      this._publishSubscribeSubject$.next({
        channel,
        payload: data,
      });
    }
  }

  public of(channel: LogChannel, handler: (value: LoggingMessageInterface) => void): Subscription {
    return this._emitter$
      .pipe(
        filter((emission) => emission.channel === channel),
        map((emission) => emission.payload)
      )
      .subscribe(handler);
  }
}
